/** Корень сайта. Пустая строка = страницы на `/vozmozhnosti`, `/dlya-fitnesa` и т.д. */
export const BASE = "";

const page = (slug) => (BASE ? `${BASE}/${slug}` : `/${slug}`);

export const PATHS = {
  home: BASE || "/",
  features: page("vozmozhnosti"),
  pricing: page("tarify"),
  audience: page("dlya-kogo"),
  connect: page("podklyuchenie"),
  about: page("o-kompanii"),
};

export const NAV_FEATURES = [
  {
    to: `${PATHS.features}#schedule`,
    title: "Календарь",
    text: "Группы, залы и тренеры",
  },
  {
    to: `${PATHS.features}#journal`,
    title: "Журнал",
    text: "Посещения и списание занятий",
  },
  {
    to: `${PATHS.features}#finance`,
    title: "Финансы и банк",
    text: "Учёт оплат, ЮKassa и Т-Банк",
  },
  {
    to: `${PATHS.features}#client`,
    title: "Кабинет клиента",
    text: "Остаток занятий и ближайшая тренировка",
  },
  {
    to: `${PATHS.features}#trainer`,
    title: "Кабинет тренера",
    text: "Свои группы, расписание и журнал",
  },
  {
    to: `${PATHS.features}#chat`,
    title: "Чат и опросы",
    text: "Переписка, push и явка",
  },
  {
    to: `${PATHS.features}#social`,
    title: "Соцсеть",
    text: "Профили, стена и лента клуба",
  },
  {
    to: `${PATHS.features}#branding`,
    title: "Брендинг",
    text: "Логотип, цвета и свой экран",
  },
];

/** Публичное меню «Для кого» — только эти страницы кликабельны и в индексе. */
export const DIRECTION_LINKS = [
  { to: page("dlya-fitnesa"), title: "Фитнес-клубы", text: "Группы и персональные" },
  { to: page("dlya-yogi"), title: "Йога и пилатес", text: "Классы и абонементы" },
  { to: page("dlya-tancev"), title: "Танцы", text: "Студии и школы танцев" },
  { to: page("dlya-edinoborstv"), title: "Единоборства", text: "Карате, дзюдо, бокс, ММА" },
  { to: page("dlya-gimnastiki"), title: "Гимнастика", text: "Художественная и спортивная" },
  { to: page("dlya-plavaniya"), title: "Плавание", text: "Школы и бассейны" },
  { to: page("dlya-rastyazhki"), title: "Студии растяжки", text: "Группы и персональные" },
  { to: page("dlya-saykla"), title: "Сайкл-студии", text: "Классы по расписанию" },
  { to: page("dlya-futbola"), title: "Футбол", text: "Секции и футбольные школы" },
];

/** Страницы есть, но пока не в меню: плашки без ссылок, noindex. */
export const FORMAT_LINKS = [
  { to: page("dlya-detskih-sekcij"), title: "Детские секции", text: "Группы и родители" },
  { to: page("dlya-sportivnyh-shkol"), title: "Спортивные школы", text: "Несколько направлений" },
  { to: page("dlya-setey"), title: "Сети клубов", text: "Несколько площадок" },
  { to: "/dlya-trenera", title: "Персональный тренер", text: "Свои ученики и расписание" },
];

export const NICHE_LINKS = DIRECTION_LINKS;

export const AUDIENCE_MENU_PATHS = new Set(DIRECTION_LINKS.map((item) => item.to));

export function isAudienceMenuPath(to) {
  return Boolean(to) && AUDIENCE_MENU_PATHS.has(to);
}

export const NICHE_PAGES_PATHS = Object.fromEntries(
  [...DIRECTION_LINKS, ...FORMAT_LINKS].map(({ title, to }) => [title, to]),
);

export const AUDIENCE_LEAD =
  "CRM для спортивных клубов, студий, школ, секций и персональных тренеров. Подходит для любого вида спорта — от фитнеса и единоборств до лыж и сноуборда.";

export const AUDIENCE_MENU_LEAD =
  "Клубам, студиям, школам, секциям и тренерам. Любой вид спорта.";

/** Куда ведёт кнопка «Показать на демо» из меню. */
export const AUDIENCE_DEMO = `${PATHS.audience}#register`;

/** Карточки «для кого»: описание формата работы. */
export const ORG_TYPES = [
  {
    id: "fitnes",
    title: "Фитнес-клубы и сети",
    text: "Группы, персональные, абонементы, несколько площадок.",
  },
  {
    id: "studii",
    title: "Студии и школы",
    text: "Йога, пилатес, танцы, растяжка, сайкл.",
  },
  {
    id: "sekcii",
    title: "Секции и спортивные школы",
    text: "Единоборства, гимнастика, плавание, футбол, лыжи и сноуборд.",
  },
  {
    id: "deti",
    title: "Детские спортивные центры",
    text: "Группы, родители, расписание.",
  },
  {
    id: "trener",
    title: "Персональные тренеры",
    text: "Свои ученики и расписание.",
  },
  {
    id: "multi",
    title: "Многопрофильные клубы",
    text: "Несколько направлений и площадок.",
  },
];

/** Короткое меню «Для кого»: только виды спорта, у которых уже есть страница. */
export const MENU_SPORTS = [
  { to: page("dlya-edinoborstv"), title: "Единоборства", text: "Карате, дзюдо, бокс, ММА" },
  { to: page("dlya-tancev"), title: "Танцы", text: "Студии и школы танцев" },
  { to: page("dlya-gimnastiki"), title: "Гимнастика", text: "Художественная и спортивная" },
  { to: page("dlya-plavaniya"), title: "Плавание", text: "Школы и бассейны" },
  { to: page("dlya-futbola"), title: "Футбол", text: "Секции и футбольные школы" },
  { to: page("dlya-yogi"), title: "Йога и пилатес", text: "Классы и абонементы" },
  { to: page("dlya-fitnesa"), title: "Фитнес", text: "Группы и персональные" },
];

/** Относительный сегмент маршрута ниши внутри VioletClarityLanding. */
export function nicheRouteSegment(pagePath) {
  const prefix = BASE ? `${BASE}/` : "/";
  if (pagePath.startsWith(prefix)) return pagePath.slice(prefix.length);
  return String(pagePath || "").replace(/^\//, "");
}

export const FOOTER_COLS = [
  {
    title: "Продукт",
    links: [
      { to: PATHS.features, label: "Возможности" },
      { to: PATHS.pricing, label: "Тарифы и модули" },
      { href: `${PATHS.home}#app`, label: "Приложение клуба" },
      { to: PATHS.connect, label: "Подключение" },
      { href: "#register", label: "Создать клуб" },
    ],
  },
  {
    title: "Для кого",
    links: [
      ...DIRECTION_LINKS.map(({ to, title }) => ({ to, label: title })),
      { to: PATHS.audience, label: "Все сценарии" },
    ],
  },
  {
    title: "Компания",
    links: [
      { to: PATHS.about, label: "О компании" },
      { href: `${PATHS.home}#faq`, label: "Вопросы и ответы" },
      { to: "/account/login", label: "Войти в кабинет" },
    ],
  },
];

export const IMG = {
  logo: "/landing/v3/logo.png",
  hero: "/landing/v3/hero.jpg",
  a: "/landing/v3/feature-1.jpg",
  b: "/landing/v3/feature-2.jpg",
  c: "/landing/v3/feature-3.jpg",
};
